import {
  AfterViewInit,
  Component, Inject, PLATFORM_ID,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {releaseFileUploadPreview} from '../../../media/media-uploader/file-upload-preview';
import {isPlatformBrowser} from '@angular/common';
import {PreparedMediaSelection} from '../../../media/media-uploader/media-selection';
import {ImageCropResult, ImageCropState} from '../../../image-cropper/image-crop-state';
import { ModalInterface } from '../../modal.interface';
import { defer, forkJoin, merge, Observable, of, Subject } from 'rxjs';
import { ModalStateEvent } from '../../modal-state-event';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RxFormBuilder, RxwebValidators } from '@rxweb/reactive-form-validators';
import { ModalState } from '../../modal-state.enum';
import { MediaObjectRestService } from '../../../../api/services/media-object.rest.service';
import { MediaObjectApiModel } from '../../../../api/models/media-object.api-model';
import { filter, finalize, ignoreElements, map, mergeMap, take, takeUntil, tap } from 'rxjs/operators';
import { EventApiModel } from '../../../../api/models/event.api.model';
import { EventViewModel } from './event.view-model';
import { AddEventProviderService } from './add-event.provider.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { add, roundToNearestMinutes } from 'date-fns';
import { PostApiModel } from '../../../../api/models/post-api.model';
import { PostTypeEnum } from '../../../../core/enums/post-type.enum';
import { PostRestService } from '../../../../api/services/post-rest.service';
import { MapService } from '../../../map/map.service';
import {getAddressCoordinates} from '../../../map/address-coordinates';
import { UserViewModel } from '../../../../features/user/settings/user.view-model';
import { TokenDataProviderService } from '../../../../core/services/token-data-provider.service';
import { CurrentUserViewModel } from '../../../../core/models/current-user.view-model';
import { LoaderService } from '../../../../core/services/loader.service';
import { ResponseErrorsHandlerService } from '../../../../core/services/response-errors-handler.service';
import { RemoveHtmlTagsPipe } from '../../../../core/pipes/remove-html-tags.pipe';
import { TranslateService } from "@ngx-translate/core";
import { HashtagValidator } from "../../../../core/validators/hashtag-validator";
import { AutoComplete } from "primeng/autocomplete";
import { ModalComponent } from "../../modal.component";
import { MediaUploadService } from "../../../../core/services/media-upload.service";
import { MediaObjectPipe } from "../../../../core/pipes/media-object.pipe";
import { FileUpload } from "primeng/fileupload";
import { QueryParamsApiModel } from "../../../../api/models/query-params-api.model";
import { ParticipantApiModel } from "../../../../api/models/participant.api.model";
import { FilterParameterApiModel } from "../../../../api/models/filter-parameter.api.model";
import { ResultListApiModel } from "../../../../api/models/result-list.api.model";
import { MediaUploaderComponent } from "../../../media/media-uploader/media-uploader.component";
import { MediaObjectViewModel } from "../../../../core/models/media-object.view-model";
import { FollowApiModel } from "../../../../api/models/follow.api-model";
import { UserApiModel } from "../../../../api/models/user.api-model";

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss'],
  providers: [AddEventProviderService]
})
export class AddEventComponent implements ModalInterface, OnInit, AfterViewInit, OnDestroy {
  get eventDates(): UntypedFormArray {
    if (this.form) {
      return this.form.get('eventDates') as UntypedFormArray;
    }
  }

  public data: any;
  public parent?: ModalComponent;
  public subject: Subject<ModalStateEvent>;
  public state: Observable<ModalStateEvent>;
  public form: UntypedFormGroup;
  public image: File | null = null;
  public coverSourceFile?: File;
  public coverCropState?: ImageCropState;
  public coverEditing = false;
  public coverDirty = false;
  public galleryBusy = false;
  public galleryLoading = false;
  public galleryLoadError = false;
  public saveError = false;
  private saving = false;
  private readonly destroyed$ = new Subject<void>();
  private uploadedCover?: MediaObjectApiModel;
  private galleryPosts: PostApiModel[] = [];
  private readonly createdMediaPosts = new Map<number, {mediaId: string; post: PostApiModel}>();
  private pendingGallery: MediaObjectApiModel[] | null = null;

  get coverMedia(): MediaObjectApiModel | undefined {
    if (this.coverDirty || !this.eventAM?.cover) { return undefined; }
    return typeof this.eventAM.cover === 'string'
      ? Object.assign(new MediaObjectApiModel(), {'@id': this.eventAM.cover, hyperlinks: []}) : this.eventAM.cover;
  }

  get coverPreview(): string {
    return this.objectURL || (this.coverMedia ? MediaObjectPipe.transformToLink(this.coverMedia, {formatType: 'thumb_md', defaultImageType: 'background'}) : '');
  }

  get mediaBusy(): boolean { return this.coverEditing || this.galleryBusy || this.galleryLoading; }

  updateMediaBusy(): void { this.parent.btnDisabled = this.mediaBusy || this.parent.loading; }

  chooseCover(): void {
    if (!isPlatformBrowser(this.platformId) || this.parent.loading || this.mediaBusy) { return; }
    this.coverUploader.choose();
  }

  editCover(): void {
    if (this.parent.loading || this.mediaBusy || !isPlatformBrowser(this.platformId)) { return; }
    this.coverEditing = true;
    this.updateMediaBusy();
  }

  closeCoverEditor(): void { this.coverEditing = false; this.updateMediaBusy(); }

  acceptCoverCrop(result: ImageCropResult): void {
    this.coverSourceFile = result.source;
    this.coverCropState = result.state;
    this.setCoverFile(result.file);
    this.closeCoverEditor();
  }

  private setCoverFile(file: File): void {
    this.releaseCoverPreview();
    this.image = file;
    this.coverDirty = true;
    this.uploadedCover = undefined;
    if (isPlatformBrowser(this.platformId)) { this.objectURL = URL.createObjectURL(file); }
  }

  private releaseCoverPreview(): void {
    if (this.objectURL && isPlatformBrowser(this.platformId)) { URL.revokeObjectURL(this.objectURL); }
    this.objectURL = '';
  }
  public objectURL = '';
  public organizers: any[] = [];
  public invitedUsers: any[] = [];
  public followers: any[] = [];
  public isLoadingFollowers = false;
  public showVisibilityEditor = false;
  public visibilityOptions: SelectItem[] = [];
  public options: any;
  public eventVM: EventViewModel;
  public eventAM: EventApiModel;
  public currentUserVM: CurrentUserViewModel;
  public files: File[] = [];
  public disabled = false;
  public mediaProgress?: number;

  public mediaObjectAMs: MediaObjectApiModel[] = [];
  @ViewChild('coverUploader') public coverUploader: FileUpload;
  @ViewChild('mediaUploaderComponent') public mediaUploaderComponent: MediaUploaderComponent;
  @ViewChildren(AutoComplete)
  private queryList: QueryList<AutoComplete>;

  // @ViewChild(GMap) gmap: GMap;

  constructor(
    private readonly fb: RxFormBuilder,
    private readonly renderer: Renderer2,
    private readonly mediaObjectRS: MediaObjectRestService,
    public readonly eventPS: AddEventProviderService,
    private readonly postRS: PostRestService,
    private readonly mapService: MapService,
    private readonly tokenDP: TokenDataProviderService,
    private readonly ls: LoaderService,
    private readonly reh: ResponseErrorsHandlerService,
    private readonly translator: TranslateService,
    private readonly mediaUploadService: MediaUploadService,
    private readonly confirmationService: ConfirmationService,
    private readonly sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {
  }

  public ngOnInit() {
    this.parent.proceedButtonBadge = null;
    this.parent.progress = null;
    this.parent.loading = false;
    this.eventAM = this.data.eventAM;
    this.createForm();
    this.buildVisibilityOptions();
    this.state.subscribe((mse: ModalStateEvent) => {
      switch (mse.status) {
        case ModalState.PENDING:
          this.submit();
      }
    });

    this.tokenDP.currentUser.pipe(takeUntil(this.destroyed$)).subscribe((user: CurrentUserViewModel) => {
      this.currentUserVM = user;
      if (!this.eventAM?.id && user?.['@id'] && !this.organizers.some(organizer => organizer.user?.['@id'] === user['@id'])) {
        this.organizers.push(this.eventPS.createUserInterface(user));
      }
      this.loadFollowers();
    });

    this.eventPS.fetchResourcesFromQuerySubject(email => this.eventPS.findInvitationCandidate(email)).subscribe();
  }

  ngAfterViewInit(): void {
    if (this.pendingGallery) {
      this.mediaUploaderComponent.initializeMedia(this.pendingGallery);
      this.pendingGallery = null;
    }
    this.queryList.forEach((e: AutoComplete) => {
      e.el.nativeElement.removeAttribute('pautofocus');
      e.inputEL?.nativeElement.removeAttribute('pautofocus');
    });
    this.mediaUploaderComponent.selectMedia(this.mediaUploaderComponent.fileUploader);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.releaseCoverPreview();
    this.eventAM = null;
  }

  private createForm() {
    const namesValidators = [
      RxwebValidators.required(),
      RxwebValidators.minLength({ value: 2 }),
      RxwebValidators.maxLength({ value: 255 })
    ];
    const searchValidators = [
      RxwebValidators.required(),
      RxwebValidators.minLength({ value: 2 }),
    ];

    this.form = this.fb.group({
      cover: [null],
      name: [null, namesValidators],
      description: ['', [RxwebValidators.minLength({ value: 2 }), RxwebValidators.maxLength({ value: 65000 })]],
      addresses: [null, searchValidators],
      eventDates: new UntypedFormArray([this.createEventDateGroup()], [RxwebValidators.choice({ minLength: 1 })]),
      organizers: new UntypedFormControl({ value: [], disabled: false }),
      visibility: new UntypedFormControl(this.eventAM?.visibility ?? 'PUBLIC'),
      invitedUsers: new UntypedFormControl({ value: [], disabled: false }),
      hashtags: new UntypedFormControl({
        value: [],
        disabled: false
      }, [HashtagValidator.maxHashtags(10, this.translator), HashtagValidator.uniqueHashtags(this.translator)]),
      metaTitle: [null],
      metaKeywords: [null],
      metaDescription: [null],
    });

    this.form.valueChanges.subscribe(() => {
      if (this.form.valid && !this.mediaBusy && !this.saving) {
        this.subject.next(new ModalStateEvent(ModalState.VALID));
      } else {
        // this.subject.next(new ModalStateEvent(ModalState.INVALID));
      }
    });

    if (this.eventAM?.id) {
      this.parent.name = this.translator.instant('common.update') + ' ' + this.eventAM.name
      this.form.patchValue({
        ...this.eventAM,
        organizers: [],
      });
      if (this.eventAM.invitations?.length) {
        this.invitedUsers = this.eventAM.invitations
          .map(invitation => invitation.invitedUser)
          .filter((invitedUser: any) => typeof invitedUser === 'object' && invitedUser !== null)
          .map((invitedUser: UserApiModel) => this.eventPS.createUserInterface(new UserViewModel(invitedUser)));
        this.form.patchValue({ invitedUsers: this.invitedUsers });
      }

      if (this.eventAM.addresses?.length) {
        const coordinates = getAddressCoordinates(this.eventAM.addresses[0]);
        if (coordinates) this.mapService.reverseGeocode(coordinates[1], coordinates[0]).pipe(takeUntil(this.destroyed$)).subscribe((reverseGeocodeRes: any) => {
          this.form.patchValue({ addresses: [{label: reverseGeocodeRes.display_name, value: reverseGeocodeRes}] });
        });
      }
    } else {
      this.parent.name = this.translator.instant('shared.modal.modal_service.add_event.title');
    }

    if (this.eventAM.organizers?.length) {
      const queryParams = new QueryParamsApiModel();
      queryParams.pagination = false;
      (this.eventAM.organizers as Array<ParticipantApiModel | string>).forEach((organizer) => {
        if (typeof organizer === 'string') {
          const slug = organizer.split('/').pop();
          if (slug) {
            queryParams.filters.push(new FilterParameterApiModel('slug', slug, 'array'));
          }
          return;
        }
        const data = organizer?.data as any;
        const slug = typeof data === 'string'
          ? data.split('/').pop()
          : (data?.slug || data?.['@id']?.split('/').pop());
        if (slug) {
          queryParams.filters.push(new FilterParameterApiModel('slug', slug, 'array'));
        }
      });
      if (!queryParams.filters.length) {
        return;
      }
      this.eventPS.fetchUsers(queryParams).subscribe(([users]: UserViewModel[][]) => {
        if (!users.length) {
          return;
        }
        this.organizers = [...users.map(u => {
          return this.eventPS.createUserInterface(u);
        })]
      });
    }

    if (this.eventAM.eventDates?.length) {
      this.createEventDateGroupFromEventAM(this.eventAM.eventDates);
    }

    if (this.eventAM.posts?.length) {
      this.loadGallery();
    }


    return this.form;
  }

  loadGallery(): void {
    this.galleryLoading = true;
    this.galleryLoadError = false;
    this.updateMediaBusy();
    this.postRS.getEventSubResourceCollection(this.eventAM['@id'], false).pipe(takeUntil(this.destroyed$)).subscribe({
      next: result => {
        this.galleryPosts = result.records.filter(post => post.type === PostTypeEnum.EVENT_MEDIA_POST);
        const media = this.galleryPosts.flatMap(post => post.media as MediaObjectApiModel[]);
        if (this.mediaUploaderComponent) { this.mediaUploaderComponent.initializeMedia(media); }
        else { this.pendingGallery = media; }
        this.galleryLoading = false;
        this.updateMediaBusy();
      },
      error: error => {
        this.galleryLoadError = true;
        this.reh.handleFormErrors(this.form, error);
      },
    });
  }

  private buildVisibilityOptions(): void {
    this.visibilityOptions = [
      { label: this.translator.instant('shared.modal.modal_service.add_event.visibility_public'), value: 'PUBLIC' },
      { label: this.translator.instant('shared.modal.modal_service.add_event.visibility_closed'), value: 'CLOSED' }
    ];
  }

  private loadFollowers(): void {
    if (!this.currentUserVM?.['@id']) {
      return;
    }
    const queryParams = new QueryParamsApiModel();
    queryParams.pagination = false;
    this.isLoadingFollowers = true;
    this.eventPS.userRS.getReceivedFollowsSubResourceCollection(this.currentUserVM['@id'], queryParams).subscribe({
      next: (resultListAM) => {
        const followedByObjects = resultListAM.records
          .map((follow: FollowApiModel) => follow.followedBy)
          .filter((followedBy: any) => typeof followedBy === 'object' && followedBy !== null) as UserApiModel[];

        const objectFollowers = followedByObjects
          .map((followedBy: UserApiModel) => this.eventPS.createUserInterface(new UserViewModel(followedBy)));

        const followedBySlugs = resultListAM.records
          .map((follow: FollowApiModel) => follow.followedBy)
          .filter((followedBy: any) => typeof followedBy === 'string')
          .map((followedBy: string) => followedBy.split('/').pop())
          .filter((slug: string) => !!slug);

        if (!followedBySlugs.length) {
          this.followers = objectFollowers;
          return;
        }

        const usersQuery = new QueryParamsApiModel();
        usersQuery.pagination = false;
        usersQuery.filters = followedBySlugs.map(slug => new FilterParameterApiModel('slug', slug, 'array'));
        this.eventPS.fetchUsers(usersQuery).subscribe({
          next: ([users]: UserViewModel[][]) => {
            const fetchedFollowers = users.map(u => this.eventPS.createUserInterface(u));
            this.followers = [...objectFollowers, ...fetchedFollowers];
          },
          error: () => {
            this.followers = objectFollowers;
          }
        });
      },
      error: () => {
        this.followers = [];
      }
    }).add(() => {
      this.isLoadingFollowers = false;
    });
  }

  createEventDateGroup(): UntypedFormGroup {
    const timeStart = roundToNearestMinutes(new Date(), { nearestTo: 15 });
    return this.fb.group({
      name: new UntypedFormControl('', [
        RxwebValidators.minLength({ value: 2 }),
        RxwebValidators.maxLength({ value: 255 }),
      ]),
      date: new UntypedFormControl(add(timeStart, { days: 1 }), [RxwebValidators.date()]),
      from: new UntypedFormControl(timeStart, [RxwebValidators.date()]),
      to: new UntypedFormControl(add(timeStart, { hours: 1 }), [RxwebValidators.date()])
    });
  }

  createEventDateGroupFromEventAM(eventDates: any[]): void {
    eventDates.forEach((eventDate) => {
      const timeStart = new Date(eventDate.start);
      const timeEnd = new Date(eventDate.end);
      this.eventDates.removeAt(0);
      this.eventDates.push(this.fb.group({
        name: new UntypedFormControl(eventDate.name, [
          RxwebValidators.minLength({ value: 2 }),
          RxwebValidators.maxLength({ value: 255 }),
        ]),
        date: new UntypedFormControl(timeStart, [RxwebValidators.date()]),
        from: new UntypedFormControl(timeStart, [RxwebValidators.date()]),
        to: new UntypedFormControl(timeEnd, [RxwebValidators.date()])
      }));
    });

  }

  public toggleCopyValuesToMetaTags(event: { checked: boolean }): void {
    if (event.checked) {
      this.copyValue(this.form, 'name', 'metaTitle');
      this.copyValue(this.form, 'description', 'metaDescription');
    } else {
      this.form.get('metaTitle').reset();
      this.form.get('metaKeywords').reset();
      this.form.get('metaDescription').reset();
    }
  }

  public copyValue(form: UntypedFormGroup, copyFromFieldName: string, subscribingFormFieldName: string): void {
    const field = form.get(subscribingFormFieldName);
    field.setValue(RemoveHtmlTagsPipe.sanitize(form.get(copyFromFieldName).value));
  }

  addDate(): void {
    const group = this.createEventDateGroup();
    this.eventDates.push(group);
  }

  removeDate(): void {
    if (this.eventDates.length > 1) {
      this.eventDates.removeAt(this.eventDates.length - 1);
    }
  }

  onUpload(event: any, type: 'single' | 'multiple') {
    if (type !== 'single' || !event.files?.length || !isPlatformBrowser(this.platformId) || this.parent.loading || this.mediaBusy) { return; }
    releaseFileUploadPreview(event.files[0], this.sanitizer);
    if (!event.files[0].type.startsWith('image/')) { this.coverUploader.clear(); return; }
    this.coverSourceFile = event.files[0];
    this.coverCropState = undefined;
    this.setCoverFile(event.files[0]);
    this.coverUploader.clear();
  }

  removeImage(): void {
    if (this.parent.loading || this.mediaBusy) { return; }
    this.releaseCoverPreview();
    this.image = null;
    this.coverSourceFile = undefined;
    this.coverCropState = undefined;
    this.uploadedCover = undefined;
    this.coverDirty = true;
  }

  public openMediaBox(): void {
    setTimeout(() => {
      const elements = document.querySelectorAll('.p-fileupload-row button');
      elements.forEach((e) => {
        this.renderer.addClass(e, 'p-button-text');
      });
    }, 1);
  }

  // addMedia(files: File[]): Observable<any> {
  //   this.disabled = true;
  //   const requests: Observable<PostApiModel>[] = [];
  //   files.forEach((file: File) => {
  //     if (!this.mediaObjectAMs.find((e: MediaObjectApiModel) => {
  //       return e.name === file.name;
  //     })) {
  //       const req = this.postMediaObject(file).pipe(mergeMap((mediaObjectAM: MediaObjectApiModel) => {
  //         const postAM = new PostApiModel();
  //         postAM.media = [];
  //         postAM.media.push(mediaObjectAM['@id']);
  //         postAM.event = this.eventVM['@id'];
  //         postAM.type = PostTypeEnum.EVENT_MEDIA_POST;
  //         postAM.content = '';
  //         return this.postRS.create(postAM);
  //       }));
  //       requests.push(req);
  //     }
  //   });
  //
  //   if (!requests.length) {
  //     return of([]);
  //   }
  //
  //   return defer(() => {
  //     let counter = 0;
  //     const percent$ = new Subject();
  //
  //     const modifiedObservablesList = requests.map(
  //       (item, index) => item.pipe(
  //         finalize(() => {
  //           const percentValue = ++counter * 100 / requests.length;
  //           percent$.next(percentValue);
  //         })
  //       )
  //     );
  //
  //     const finalResult$ = forkJoin(modifiedObservablesList).pipe(
  //       tap(() => {
  //           percent$.next(100);
  //           percent$.complete();
  //         }
  //       ));
  //
  //     return of([finalResult$, percent$.asObservable()]);
  //   }).pipe(
  //     mergeMap(([finalResult, progress]) => merge(
  //       progress.pipe(
  //         tap((value: number) => this.mediaProgress = value),
  //         ignoreElements()
  //       ),
  //       finalResult
  //     ))
  //   );
  // }

  // public submit(): void {
  //   console.log(this.form);
  //   if (this.form.valid) {
  //     if (!this.eventAM?.id) {
  //       this.eventVM = this.form.value;
  //       this.eventVM.apiModel = new EventApiModel();
  //       this.eventVM.organizers = this.organizers;
  //       this.eventVM.hashtags = this.form.get('hashtags').value.length ? this.form.get('hashtags').value : [];
  //       this.eventVM.posts = [];
  //     } else {
  //       this.eventVM = {...this.data.eventAM, ...this.form.value};
  //       this.eventVM.organizers = this.organizers;
  //     }
  //
  //     const files = this.mediaUploaderComponent.newFiles;
  //     this.mediaUploadService.uploadMedia(files)
  //       .pipe(mergeMap(({mediaObjects$, progress$}) => {
  //         progress$.subscribe((progress) => {
  //           this.parent.progress = progress; // Aktualizacja procentowego postępu
  //         });
  //
  //         return mediaObjects$.pipe(mergeMap((uploadedMedia: MediaObjectApiModel[]) => {
  //           const requests: Observable<PostApiModel>[] = [];
  //           uploadedMedia.forEach(mediaObjectAM => {
  //             const postAM = new PostApiModel();
  //             postAM.media = [];
  //             postAM.media.push(mediaObjectAM['@id']);
  //             postAM.event = this.eventVM['@id'];
  //             postAM.type = PostTypeEnum.EVENT_MEDIA_POST;
  //             postAM.content = '';
  //             requests.push(this.postRS.create(postAM));
  //           })
  //
  //           return requests.length ? forkJoin(requests) : of([]);
  //         }));
  //       }))
  //       .pipe(mergeMap((uploadedMediaPosts: PostApiModel[]) => {
  //         return this.image && this.image.name !== this.eventVM.cover.name ? this.mediaObjectRS.uploadImage(this.image).pipe(mergeMap((mediaObjectAM: MediaObjectApiModel) => {
  //           return of([uploadedMediaPosts, mediaObjectAM]);
  //         })) : of([uploadedMediaPosts, null]);
  //       }))
  //       .pipe(mergeMap(([uploadedMediaPosts, cover]: [PostApiModel[], MediaObjectApiModel]) => {
  //         console.log(uploadedMediaPosts);
  //         const newMedia = uploadedMediaPosts.map((postAM: PostApiModel) => postAM.media[0]);
  //         const existingMedia = this.mediaUploaderComponent.mediaObjectAMs.map(m => m['@id']) as string[];
  //         if (cover) {
  //           this.eventVM.cover = new MediaObjectViewModel(cover);
  //         }
  //         this.eventVM.media = [...existingMedia, ...newMedia];
  //         this.eventVM.posts = [...this.eventVM.posts, ...uploadedMediaPosts];
  //
  //         return !this.eventAM?.id ? this.eventPS.createEvent(this.eventVM) : this.eventPS.updateEvent(this.eventVM);
  //       }))
  //       .subscribe({
  //         next: (eventAM: EventApiModel) => {
  //           this.subject.next(new ModalStateEvent(ModalState.SUCCESS, eventAM));
  //
  //           this.form.reset({
  //             heading: null,
  //             dateRange: null,
  //             content: null,
  //           });
  //           this.form.markAsPristine();
  //           this.form.markAsUntouched();
  //           this.form.updateValueAndValidity();
  //           this.parent.loading = false;
  //         },
  //         error: (errorResponse) => {
  //           this.parent.progress = null;
  //
  //           this.eventVM = null;
  //           this.ls.hide();
  //           this.reh.handleFormErrors(this.form, errorResponse);
  //           this.parent.loading = false;
  //         }
  //       });
  //   } else {
  //     this.ls.hide();
  //     this.form.markAllAsTouched();
  //     this.parent.loading = false;
  //   }
  // }

  public submit(): void {
    if (this.mediaBusy || this.saving) { this.parent.loading = this.saving; return; }
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.parent.loading = false;
      this.updateMediaBusy();
      return;
    }
    this.saving = true;
    this.saveError = false;
    this.parent.loading = true;
    this.updateMediaBusy();
    this.eventVM = {
      ...(this.eventAM?.id ? this.data.eventAM : {}),
      ...this.form.value,
      apiModel: new EventApiModel(),
      cover: this.coverDirty ? null : this.eventAM?.cover,
      organizers: this.organizers,
      invitedUsers: this.invitedUsers,
      hashtags: this.form.get('hashtags')?.value ?? [],
      posts: this.eventAM?.posts || [],
    };

    this.mediaUploaderComponent.prepareMedia(progress => this.parent.progress = progress).pipe(
      mergeMap(selection => this.prepareEventPosts(selection).pipe(map(posts => ({selection, posts})))),
      mergeMap(result => {
        if (!this.coverDirty || !this.image || this.uploadedCover) { return of(result); }
        return this.mediaObjectRS.uploadImage(this.image).pipe(
          filter((media): media is MediaObjectApiModel => typeof media !== 'number'), take(1),
          tap(media => this.uploadedCover = media), map(() => result),
        );
      }),
      mergeMap(({selection, posts}) => {
        if (this.uploadedCover) { this.eventVM.cover = new MediaObjectViewModel(this.uploadedCover); }
        this.eventVM.media = selection.media.map(media => media['@id']);
        const retainedSources = new Set(this.mediaUploaderComponent.selection.entries
          .filter(entry => entry.source).map(entry => entry.source['@id']));
        const removedPostIds = new Set(this.galleryPosts.filter(post =>
          !post.media.some(media => retainedSources.has(typeof media === 'string' ? media : media['@id']))
        ).map(post => post['@id']));
        this.eventVM.posts = [...(this.eventAM?.posts || []).filter(post =>
          !removedPostIds.has(typeof post === 'string' ? post : post['@id'])), ...posts];
        this.eventVM.mediaReplacements = selection.replacements.flatMap(replacement =>
          this.galleryPosts.filter(post => post.media.some(media =>
            (typeof media === 'string' ? media : media['@id']) === replacement.source['@id']
          )).map(post => ({post: post['@id'], oldMedia: replacement.source['@id'], newMedia: replacement.media['@id']}))
        );
        // Removing one image from a multi-image post must not leave it in the gallery.
        this.eventVM.mediaReplacements.push(...this.galleryPosts.filter(post => !removedPostIds.has(post['@id']))
          .flatMap(post => post.media.map(media => typeof media === 'string' ? media : media['@id'])
            .filter(id => !retainedSources.has(id))
            .map(id => ({post: post['@id'], oldMedia: id, newMedia: null}))));
        return this.eventAM?.id ? this.eventPS.updateEvent(this.eventVM) : this.eventPS.createEvent(this.eventVM);
      }),
      takeUntil(this.destroyed$),
      finalize(() => {
        this.parent.progress = null;
        this.saving = false;
        this.parent.loading = false;
        this.updateMediaBusy();
      }),
    ).subscribe({
      next: event => this.subject.next(new ModalStateEvent(ModalState.SUCCESS, event)),
      error: error => { this.saveError = true; this.reh.handleFormErrors(this.form, error); },
    });
  }

  private prepareEventPosts(selection: PreparedMediaSelection): Observable<PostApiModel[]> {
    const requests = selection.additions.map(({entryId, media}) => {
      const cached = this.createdMediaPosts.get(entryId);
      if (cached?.mediaId === media['@id']) { return of(cached.post); }
      const post = new PostApiModel();
      post.media = [media['@id']];
      // Attach new posts only with the final event save, so a failed save can be retried.
      post.type = PostTypeEnum.EVENT_MEDIA_POST;
      post.content = '';
      return this.postRS.create(post).pipe(tap(saved =>
        this.createdMediaPosts.set(entryId, {mediaId: media['@id'], post: saved})));
    });
    return requests.length ? forkJoin(requests) : of([]);
  }

  emitQuery(queryEvt) {
    const query = String(queryEvt.query || '').trim();
    this.eventPS.resultSubject$.next(query);
  }

  addOrganizer(item: any, autocomplete: AutoComplete) {
    if (this.organizers.some(e => e.user?.['@id'] === item.user?.['@id'])) {
      return;
    }

    this.organizers.push(item);
    autocomplete.writeValue(null);
  }

  removeOrganizer(item: any) {
    this.organizers = this.organizers.filter(e => e.alias !== item.alias);
  }

  public toggleVisibilityEditor(): void {
    this.showVisibilityEditor = !this.showVisibilityEditor;
  }

  public onVisibilityChange(value: string): void {
    if (value === 'PUBLIC') {
      this.invitedUsers = [];
      this.form.get('invitedUsers').setValue([]);
    }
  }

  addInvitedUser(item: any, autocomplete: AutoComplete): void {
    if (this.invitedUsers.find(e => e.alias === item.alias)) {
      return;
    }
    if (this.currentUserVM?.id && item.id === this.currentUserVM.id) {
      return;
    }
    if (this.organizers.find(e => e.id === item.id)) {
      return;
    }

    this.invitedUsers.push(item);
    this.form.get('invitedUsers').setValue([...this.invitedUsers]);
    autocomplete.writeValue(null);
  }

  removeInvitedUser(item: any): void {
    this.invitedUsers = this.invitedUsers.filter(e => e.alias !== item.alias);
    this.form.get('invitedUsers').setValue([...this.invitedUsers]);
  }

  addFollowersToInvited(): void {
    if (!this.followers?.length) {
      return;
    }
    const existingIds = new Set(this.invitedUsers.map(u => u.id));
    this.followers.forEach(follower => {
      if (this.currentUserVM?.id && follower.id === this.currentUserVM.id) {
        return;
      }
      if (this.organizers.find(e => e.id === follower.id)) {
        return;
      }
      if (!existingIds.has(follower.id)) {
        this.invitedUsers.push(follower);
      }
    });
    this.form.get('invitedUsers').setValue([...this.invitedUsers]);
  }


  public beforeModalCloseAttempt(): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translator.instant('shared.modal.modal_service.add_event.exit_process_title'),
        message: this.translator.instant('shared.modal.modal_service.add_event.exit_process_message'),
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
